//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.16.1.0 (NJsonSchema v10.7.2.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { get } from "local-storage";
import AuthService from "../services/AuthService.service";
import { BASE_URL } from "./settings";
import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import moment from 'moment';

export class BaseClient {
    protected transformOptions(options: any) {
        const token = get<string>(AuthService.tokenKey)

        const old_headers = options.headers;
        const new_headers: { [key: string]: string } = {};
        Object.keys(old_headers).forEach((k: any) => {
            new_headers[k] = old_headers[k];
        });
        if (token && token !== '') {
            new_headers['Authorization'] = 'Bearer ' + token;
        }
        options.headers = new_headers;
        return Promise.resolve(options);
    }

    public getBaseUrl(baseUrl: string) {
        return BASE_URL;
    }
}

export class AuthClient extends BaseClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("https://localhost:5001");

    }

    authenticate(model: LoginRequest, cancelToken?: CancelToken | undefined): Promise<LoginResponse> {
        let url_ = this.baseUrl + "/api/Auth/authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAuthenticate(_response);
        });
    }

    protected processAuthenticate(response: AxiosResponse): Promise<LoginResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = LoginResponse.fromJS(resultData200);
            return Promise.resolve<LoginResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LoginResponse>(null as any);
    }
}

export class DevicesClient extends BaseClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("https://localhost:5001");

    }

    list(cancelToken?: CancelToken | undefined): Promise<DeviceSimpleDTO[]> {
        let url_ = this.baseUrl + "/api/Devices/List";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<DeviceSimpleDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeviceSimpleDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DeviceSimpleDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeviceSimpleDTO[]>(null as any);
    }

    create(device: DeviceDTO, cancelToken?: CancelToken | undefined): Promise<DeviceDTO> {
        let url_ = this.baseUrl + "/api/Devices/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(device);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<DeviceDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = DeviceDTO.fromJS(resultData200);
            return Promise.resolve<DeviceDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeviceDTO>(null as any);
    }

    update(device: DeviceDTO, cancelToken?: CancelToken | undefined): Promise<DeviceDTO> {
        let url_ = this.baseUrl + "/api/Devices/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(device);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<DeviceDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = DeviceDTO.fromJS(resultData200);
            return Promise.resolve<DeviceDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeviceDTO>(null as any);
    }

    delete(id: number, cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Devices/Delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    get(deviceKey: string | null, cancelToken?: CancelToken | undefined): Promise<DeviceDTO> {
        let url_ = this.baseUrl + "/api/Devices/Get/{deviceKey}";
        if (deviceKey === undefined || deviceKey === null)
            throw new Error("The parameter 'deviceKey' must be defined.");
        url_ = url_.replace("{deviceKey}", encodeURIComponent("" + deviceKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<DeviceDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = DeviceDTO.fromJS(resultData200);
            return Promise.resolve<DeviceDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeviceDTO>(null as any);
    }

    getNewId(cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Devices/getNewId";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNewId(_response);
        });
    }

    protected processGetNewId(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    getSettings(deviceKey: string | null, cancelToken?: CancelToken | undefined): Promise<DeviceSettingDTO> {
        let url_ = this.baseUrl + "/api/Devices/GetSettings/{deviceKey}";
        if (deviceKey === undefined || deviceKey === null)
            throw new Error("The parameter 'deviceKey' must be defined.");
        url_ = url_.replace("{deviceKey}", encodeURIComponent("" + deviceKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSettings(_response);
        });
    }

    protected processGetSettings(response: AxiosResponse): Promise<DeviceSettingDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = DeviceSettingDTO.fromJS(resultData200);
            return Promise.resolve<DeviceSettingDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeviceSettingDTO>(null as any);
    }

    setSettings(deviceKey: string | null, settings: SetSettingsDTO, cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Devices/SetSettings/{deviceKey}";
        if (deviceKey === undefined || deviceKey === null)
            throw new Error("The parameter 'deviceKey' must be defined.");
        url_ = url_.replace("{deviceKey}", encodeURIComponent("" + deviceKey));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(settings);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetSettings(_response);
        });
    }

    protected processSetSettings(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    liveData(deviceKey: string | null, liveData: boolean, cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Devices/LiveData/{deviceKey}";
        if (deviceKey === undefined || deviceKey === null)
            throw new Error("The parameter 'deviceKey' must be defined.");
        url_ = url_.replace("{deviceKey}", encodeURIComponent("" + deviceKey));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(liveData);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLiveData(_response);
        });
    }

    protected processLiveData(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class FranchiseeClient extends BaseClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("https://localhost:5001");

    }

    list(cancelToken?: CancelToken | undefined): Promise<FranchiseeDTO[]> {
        let url_ = this.baseUrl + "/api/Franchisee/List";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<FranchiseeDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FranchiseeDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<FranchiseeDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FranchiseeDTO[]>(null as any);
    }

    create(entity: CreateFranchiseeDTO, cancelToken?: CancelToken | undefined): Promise<FranchiseeDTO> {
        let url_ = this.baseUrl + "/api/Franchisee/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<FranchiseeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = FranchiseeDTO.fromJS(resultData200);
            return Promise.resolve<FranchiseeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FranchiseeDTO>(null as any);
    }

    update(entity: UpdateFranchiseeDTO, cancelToken?: CancelToken | undefined): Promise<FranchiseeDTO> {
        let url_ = this.baseUrl + "/api/Franchisee/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<FranchiseeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = FranchiseeDTO.fromJS(resultData200);
            return Promise.resolve<FranchiseeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FranchiseeDTO>(null as any);
    }

    delete(id: number, cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Franchisee/Delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    get(id: number, cancelToken?: CancelToken | undefined): Promise<FranchiseeDTO> {
        let url_ = this.baseUrl + "/api/Franchisee/Get/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<FranchiseeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = FranchiseeDTO.fromJS(resultData200);
            return Promise.resolve<FranchiseeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FranchiseeDTO>(null as any);
    }
}

export class GrindClient extends BaseClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("https://localhost:5001");

    }

    list(pagination: Pagination, cancelToken?: CancelToken | undefined): Promise<PaginationResponseOfGrindingDTO> {
        let url_ = this.baseUrl + "/api/Grind/List";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pagination);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<PaginationResponseOfGrindingDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = PaginationResponseOfGrindingDTO.fromJS(resultData200);
            return Promise.resolve<PaginationResponseOfGrindingDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaginationResponseOfGrindingDTO>(null as any);
    }

    listForDevice(deviceId: number | undefined, cancelToken?: CancelToken | undefined): Promise<GrindingDTO[]> {
        let url_ = this.baseUrl + "/api/Grind/ListForDevice?";
        if (deviceId === null)
            throw new Error("The parameter 'deviceId' cannot be null.");
        else if (deviceId !== undefined)
            url_ += "deviceId=" + encodeURIComponent("" + deviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListForDevice(_response);
        });
    }

    protected processListForDevice(response: AxiosResponse): Promise<GrindingDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GrindingDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GrindingDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GrindingDTO[]>(null as any);
    }

    update(device: GrindingDTO, cancelToken?: CancelToken | undefined): Promise<GrindingDTO> {
        let url_ = this.baseUrl + "/api/Grind/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(device);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<GrindingDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = GrindingDTO.fromJS(resultData200);
            return Promise.resolve<GrindingDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GrindingDTO>(null as any);
    }

    delete(id: number, cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Grind/Delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    deleteAllForDevice(deviceId: number | undefined, cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Grind/DeleteAllForDevice?";
        if (deviceId === null)
            throw new Error("The parameter 'deviceId' cannot be null.");
        else if (deviceId !== undefined)
            url_ += "deviceId=" + encodeURIComponent("" + deviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteAllForDevice(_response);
        });
    }

    protected processDeleteAllForDevice(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    exportDeviceData(deviceId: number | undefined, startDate: moment.Moment | undefined, stopDate: moment.Moment | undefined, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Grind/ExportDeviceData?";
        if (deviceId === null)
            throw new Error("The parameter 'deviceId' cannot be null.");
        else if (deviceId !== undefined)
            url_ += "deviceId=" + encodeURIComponent("" + deviceId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (stopDate === null)
            throw new Error("The parameter 'stopDate' cannot be null.");
        else if (stopDate !== undefined)
            url_ += "stopDate=" + encodeURIComponent(stopDate ? "" + stopDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportDeviceData(_response);
        });
    }

    protected processExportDeviceData(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class LogsClient extends BaseClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("https://localhost:5001");

    }

    logs(deviceId: number | undefined, types: LogType[], cancelToken?: CancelToken | undefined): Promise<DeviceLogDTO[]> {
        let url_ = this.baseUrl + "/api/Logs?";
        if (deviceId === null)
            throw new Error("The parameter 'deviceId' cannot be null.");
        else if (deviceId !== undefined)
            url_ += "deviceId=" + encodeURIComponent("" + deviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(types);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogs(_response);
        });
    }

    protected processLogs(response: AxiosResponse): Promise<DeviceLogDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeviceLogDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DeviceLogDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeviceLogDTO[]>(null as any);
    }
}

export class StatisticsClient extends BaseClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("https://localhost:5001");

    }

    millStatistics(franchiseeeId: number | undefined, fromDate: moment.Moment | undefined, toDate: moment.Moment | undefined, cancelToken?: CancelToken | undefined): Promise<StatisticsMillDTO> {
        let url_ = this.baseUrl + "/api/Statistics/MillStatistics?";
        if (franchiseeeId === null)
            throw new Error("The parameter 'franchiseeeId' cannot be null.");
        else if (franchiseeeId !== undefined)
            url_ += "franchiseeeId=" + encodeURIComponent("" + franchiseeeId) + "&";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMillStatistics(_response);
        });
    }

    protected processMillStatistics(response: AxiosResponse): Promise<StatisticsMillDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = StatisticsMillDTO.fromJS(resultData200);
            return Promise.resolve<StatisticsMillDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StatisticsMillDTO>(null as any);
    }
}

export class UsersClient extends BaseClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("https://localhost:5001");

    }

    list(franchiseId: number, cancelToken?: CancelToken | undefined): Promise<UserDTO[]> {
        let url_ = this.baseUrl + "/api/Users/List/{franchiseId}";
        if (franchiseId === undefined || franchiseId === null)
            throw new Error("The parameter 'franchiseId' must be defined.");
        url_ = url_.replace("{franchiseId}", encodeURIComponent("" + franchiseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<UserDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UserDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDTO[]>(null as any);
    }

    create(entity: UserDTO, cancelToken?: CancelToken | undefined): Promise<UserDTO> {
        let url_ = this.baseUrl + "/api/Users/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<UserDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = UserDTO.fromJS(resultData200);
            return Promise.resolve<UserDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDTO>(null as any);
    }

    update(entity: UserDTO, cancelToken?: CancelToken | undefined): Promise<UserDTO> {
        let url_ = this.baseUrl + "/api/Users/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<UserDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = UserDTO.fromJS(resultData200);
            return Promise.resolve<UserDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDTO>(null as any);
    }

    delete(id: number, cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Users/Delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    get(id: number, cancelToken?: CancelToken | undefined): Promise<UserDTO> {
        let url_ = this.baseUrl + "/api/Users/Get/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<UserDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = UserDTO.fromJS(resultData200);
            return Promise.resolve<UserDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDTO>(null as any);
    }
}

export class Response implements IResponse {
    error?: string | null;

    constructor(data?: IResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"] !== undefined ? _data["error"] : <any>null;
        }
    }

    static fromJS(data: any): Response {
        data = typeof data === 'object' ? data : {};
        let result = new Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error !== undefined ? this.error : <any>null;
        return data;
    }

    clone(): Response {
        const json = this.toJSON();
        let result = new Response();
        result.init(json);
        return result;
    }
}

export interface IResponse {
    error?: string | null;
}

export class LoginResponse extends Response implements ILoginResponse {
    token?: string | null;

    constructor(data?: ILoginResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.token = _data["token"] !== undefined ? _data["token"] : <any>null;
        }
    }

    static override fromJS(data: any): LoginResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LoginResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token !== undefined ? this.token : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): LoginResponse {
        const json = this.toJSON();
        let result = new LoginResponse();
        result.init(json);
        return result;
    }
}

export interface ILoginResponse extends IResponse {
    token?: string | null;
}

export class LoginRequest implements ILoginRequest {
    login?: string | null;
    password?: string | null;

    constructor(data?: ILoginRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.login = _data["login"] !== undefined ? _data["login"] : <any>null;
            this.password = _data["password"] !== undefined ? _data["password"] : <any>null;
        }
    }

    static fromJS(data: any): LoginRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LoginRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["login"] = this.login !== undefined ? this.login : <any>null;
        data["password"] = this.password !== undefined ? this.password : <any>null;
        return data;
    }

    clone(): LoginRequest {
        const json = this.toJSON();
        let result = new LoginRequest();
        result.init(json);
        return result;
    }
}

export interface ILoginRequest {
    login?: string | null;
    password?: string | null;
}

export class BaseEntityDTO implements IBaseEntityDTO {
    id?: number;

    constructor(data?: IBaseEntityDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): BaseEntityDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BaseEntityDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }

    clone(): BaseEntityDTO {
        const json = this.toJSON();
        let result = new BaseEntityDTO();
        result.init(json);
        return result;
    }
}

export interface IBaseEntityDTO {
    id?: number;
}

export class ActiveRowDTO extends BaseEntityDTO implements IActiveRowDTO {
    isActive?: ActiveStatus | null;

    constructor(data?: IActiveRowDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
        }
    }

    static override fromJS(data: any): ActiveRowDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveRowDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): ActiveRowDTO {
        const json = this.toJSON();
        let result = new ActiveRowDTO();
        result.init(json);
        return result;
    }
}

export interface IActiveRowDTO extends IBaseEntityDTO {
    isActive?: ActiveStatus | null;
}

export class DeviceSimpleDTO extends ActiveRowDTO implements IDeviceSimpleDTO {
    name?: string | null;
    key?: string | null;
    bcmsId?: string | null;
    onlineState?: OnlineState | null;
    description?: string | null;
    franchiseeId?: number | null;
    isActivated?: boolean;
    timeForKg?: number;
    franchiseeName?: string | null;
    millIdentifier?: string | null;
    posIdentifier?: string | null;

    constructor(data?: IDeviceSimpleDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.key = _data["key"] !== undefined ? _data["key"] : <any>null;
            this.bcmsId = _data["bcmsId"] !== undefined ? _data["bcmsId"] : <any>null;
            this.onlineState = _data["onlineState"] !== undefined ? _data["onlineState"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.franchiseeId = _data["franchiseeId"] !== undefined ? _data["franchiseeId"] : <any>null;
            this.isActivated = _data["isActivated"] !== undefined ? _data["isActivated"] : <any>null;
            this.timeForKg = _data["timeForKg"] !== undefined ? _data["timeForKg"] : <any>null;
            this.franchiseeName = _data["franchiseeName"] !== undefined ? _data["franchiseeName"] : <any>null;
            this.millIdentifier = _data["millIdentifier"] !== undefined ? _data["millIdentifier"] : <any>null;
            this.posIdentifier = _data["posIdentifier"] !== undefined ? _data["posIdentifier"] : <any>null;
        }
    }

    static override fromJS(data: any): DeviceSimpleDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceSimpleDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["key"] = this.key !== undefined ? this.key : <any>null;
        data["bcmsId"] = this.bcmsId !== undefined ? this.bcmsId : <any>null;
        data["onlineState"] = this.onlineState !== undefined ? this.onlineState : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["franchiseeId"] = this.franchiseeId !== undefined ? this.franchiseeId : <any>null;
        data["isActivated"] = this.isActivated !== undefined ? this.isActivated : <any>null;
        data["timeForKg"] = this.timeForKg !== undefined ? this.timeForKg : <any>null;
        data["franchiseeName"] = this.franchiseeName !== undefined ? this.franchiseeName : <any>null;
        data["millIdentifier"] = this.millIdentifier !== undefined ? this.millIdentifier : <any>null;
        data["posIdentifier"] = this.posIdentifier !== undefined ? this.posIdentifier : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): DeviceSimpleDTO {
        const json = this.toJSON();
        let result = new DeviceSimpleDTO();
        result.init(json);
        return result;
    }
}

export interface IDeviceSimpleDTO extends IActiveRowDTO {
    name?: string | null;
    key?: string | null;
    bcmsId?: string | null;
    onlineState?: OnlineState | null;
    description?: string | null;
    franchiseeId?: number | null;
    isActivated?: boolean;
    timeForKg?: number;
    franchiseeName?: string | null;
    millIdentifier?: string | null;
    posIdentifier?: string | null;
}

export enum OnlineState {
    Offline = 0,
    Online = 1,
}

export enum ActiveStatus {
    Active = 1,
    InActive = -1,
}

export class DeviceDTO extends ActiveRowDTO implements IDeviceDTO {
    name?: string | null;
    key?: string | null;
    bcmsId?: string | null;
    onlineState?: OnlineState | null;
    grindings?: GrindingDTO[] | null;
    description?: string | null;
    franchiseeId?: number | null;
    isActivated?: boolean;
    timeForKg?: number;
    franchiseeName?: string | null;
    millIdentifier?: string | null;
    posIdentifier?: string | null;

    constructor(data?: IDeviceDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.key = _data["key"] !== undefined ? _data["key"] : <any>null;
            this.bcmsId = _data["bcmsId"] !== undefined ? _data["bcmsId"] : <any>null;
            this.onlineState = _data["onlineState"] !== undefined ? _data["onlineState"] : <any>null;
            if (Array.isArray(_data["grindings"])) {
                this.grindings = [] as any;
                for (let item of _data["grindings"])
                    this.grindings!.push(GrindingDTO.fromJS(item));
            }
            else {
                this.grindings = <any>null;
            }
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.franchiseeId = _data["franchiseeId"] !== undefined ? _data["franchiseeId"] : <any>null;
            this.isActivated = _data["isActivated"] !== undefined ? _data["isActivated"] : <any>null;
            this.timeForKg = _data["timeForKg"] !== undefined ? _data["timeForKg"] : <any>null;
            this.franchiseeName = _data["franchiseeName"] !== undefined ? _data["franchiseeName"] : <any>null;
            this.millIdentifier = _data["millIdentifier"] !== undefined ? _data["millIdentifier"] : <any>null;
            this.posIdentifier = _data["posIdentifier"] !== undefined ? _data["posIdentifier"] : <any>null;
        }
    }

    static override fromJS(data: any): DeviceDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["key"] = this.key !== undefined ? this.key : <any>null;
        data["bcmsId"] = this.bcmsId !== undefined ? this.bcmsId : <any>null;
        data["onlineState"] = this.onlineState !== undefined ? this.onlineState : <any>null;
        if (Array.isArray(this.grindings)) {
            data["grindings"] = [];
            for (let item of this.grindings)
                data["grindings"].push(item.toJSON());
        }
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["franchiseeId"] = this.franchiseeId !== undefined ? this.franchiseeId : <any>null;
        data["isActivated"] = this.isActivated !== undefined ? this.isActivated : <any>null;
        data["timeForKg"] = this.timeForKg !== undefined ? this.timeForKg : <any>null;
        data["franchiseeName"] = this.franchiseeName !== undefined ? this.franchiseeName : <any>null;
        data["millIdentifier"] = this.millIdentifier !== undefined ? this.millIdentifier : <any>null;
        data["posIdentifier"] = this.posIdentifier !== undefined ? this.posIdentifier : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): DeviceDTO {
        const json = this.toJSON();
        let result = new DeviceDTO();
        result.init(json);
        return result;
    }
}

export interface IDeviceDTO extends IActiveRowDTO {
    name?: string | null;
    key?: string | null;
    bcmsId?: string | null;
    onlineState?: OnlineState | null;
    grindings?: GrindingDTO[] | null;
    description?: string | null;
    franchiseeId?: number | null;
    isActivated?: boolean;
    timeForKg?: number;
    franchiseeName?: string | null;
    millIdentifier?: string | null;
    posIdentifier?: string | null;
}

export class GrindingDTO extends ActiveRowDTO implements IGrindingDTO {
    deviceId?: number;
    time?: number;
    deviceName?: string | null;
    deviceKey?: string | null;
    createDate?: moment.Moment;
    receivedDate?: moment.Moment;

    constructor(data?: IGrindingDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.deviceId = _data["deviceId"] !== undefined ? _data["deviceId"] : <any>null;
            this.time = _data["time"] !== undefined ? _data["time"] : <any>null;
            this.deviceName = _data["deviceName"] !== undefined ? _data["deviceName"] : <any>null;
            this.deviceKey = _data["deviceKey"] !== undefined ? _data["deviceKey"] : <any>null;
            this.createDate = _data["createDate"] ? moment(_data["createDate"].toString()) : <any>null;
            this.receivedDate = _data["receivedDate"] ? moment(_data["receivedDate"].toString()) : <any>null;
        }
    }

    static override fromJS(data: any): GrindingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GrindingDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceId"] = this.deviceId !== undefined ? this.deviceId : <any>null;
        data["time"] = this.time !== undefined ? this.time : <any>null;
        data["deviceName"] = this.deviceName !== undefined ? this.deviceName : <any>null;
        data["deviceKey"] = this.deviceKey !== undefined ? this.deviceKey : <any>null;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>null;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): GrindingDTO {
        const json = this.toJSON();
        let result = new GrindingDTO();
        result.init(json);
        return result;
    }
}

export interface IGrindingDTO extends IActiveRowDTO {
    deviceId?: number;
    time?: number;
    deviceName?: string | null;
    deviceKey?: string | null;
    createDate?: moment.Moment;
    receivedDate?: moment.Moment;
}

export class DeviceSettingDTO extends ActiveRowDTO implements IDeviceSettingDTO {
    network?: { [key: string]: MqttInfoNetworkInterface[]; } | null;
    idle?: number;

    constructor(data?: IDeviceSettingDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (_data["network"]) {
                this.network = {} as any;
                for (let key in _data["network"]) {
                    if (_data["network"].hasOwnProperty(key))
                        (<any>this.network)![key] = _data["network"][key] ? _data["network"][key].map((i: any) => MqttInfoNetworkInterface.fromJS(i)) : [];
                }
            }
            else {
                this.network = <any>null;
            }
            this.idle = _data["idle"] !== undefined ? _data["idle"] : <any>null;
        }
    }

    static override fromJS(data: any): DeviceSettingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceSettingDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.network) {
            data["network"] = {};
            for (let key in this.network) {
                if (this.network.hasOwnProperty(key))
                    (<any>data["network"])[key] = this.network[key] !== undefined ? this.network[key] : <any>null;
            }
        }
        data["idle"] = this.idle !== undefined ? this.idle : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): DeviceSettingDTO {
        const json = this.toJSON();
        let result = new DeviceSettingDTO();
        result.init(json);
        return result;
    }
}

export interface IDeviceSettingDTO extends IActiveRowDTO {
    network?: { [key: string]: MqttInfoNetworkInterface[]; } | null;
    idle?: number;
}

export class MqttInfoNetworkInterface implements IMqttInfoNetworkInterface {
    address?: string | null;
    netmask?: string | null;
    family?: string | null;
    mac?: string | null;

    constructor(data?: IMqttInfoNetworkInterface) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address = _data["address"] !== undefined ? _data["address"] : <any>null;
            this.netmask = _data["netmask"] !== undefined ? _data["netmask"] : <any>null;
            this.family = _data["family"] !== undefined ? _data["family"] : <any>null;
            this.mac = _data["mac"] !== undefined ? _data["mac"] : <any>null;
        }
    }

    static fromJS(data: any): MqttInfoNetworkInterface {
        data = typeof data === 'object' ? data : {};
        let result = new MqttInfoNetworkInterface();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address !== undefined ? this.address : <any>null;
        data["netmask"] = this.netmask !== undefined ? this.netmask : <any>null;
        data["family"] = this.family !== undefined ? this.family : <any>null;
        data["mac"] = this.mac !== undefined ? this.mac : <any>null;
        return data;
    }

    clone(): MqttInfoNetworkInterface {
        const json = this.toJSON();
        let result = new MqttInfoNetworkInterface();
        result.init(json);
        return result;
    }
}

export interface IMqttInfoNetworkInterface {
    address?: string | null;
    netmask?: string | null;
    family?: string | null;
    mac?: string | null;
}

export class SetSettingsDTO implements ISetSettingsDTO {
    idle?: number;

    constructor(data?: ISetSettingsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idle = _data["idle"] !== undefined ? _data["idle"] : <any>null;
        }
    }

    static fromJS(data: any): SetSettingsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SetSettingsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idle"] = this.idle !== undefined ? this.idle : <any>null;
        return data;
    }

    clone(): SetSettingsDTO {
        const json = this.toJSON();
        let result = new SetSettingsDTO();
        result.init(json);
        return result;
    }
}

export interface ISetSettingsDTO {
    idle?: number;
}

export class FranchiseeDTO extends ActiveRowDTO implements IFranchiseeDTO {
    name?: string | null;
    description?: string | null;
    identifier?: string | null;
    coffeeDelta?: number;

    constructor(data?: IFranchiseeDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.identifier = _data["identifier"] !== undefined ? _data["identifier"] : <any>null;
            this.coffeeDelta = _data["coffeeDelta"] !== undefined ? _data["coffeeDelta"] : <any>null;
        }
    }

    static override fromJS(data: any): FranchiseeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FranchiseeDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["identifier"] = this.identifier !== undefined ? this.identifier : <any>null;
        data["coffeeDelta"] = this.coffeeDelta !== undefined ? this.coffeeDelta : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): FranchiseeDTO {
        const json = this.toJSON();
        let result = new FranchiseeDTO();
        result.init(json);
        return result;
    }
}

export interface IFranchiseeDTO extends IActiveRowDTO {
    name?: string | null;
    description?: string | null;
    identifier?: string | null;
    coffeeDelta?: number;
}

export class CreateFranchiseeDTO extends FranchiseeDTO implements ICreateFranchiseeDTO {
    devices?: DeviceDTO[] | null;

    constructor(data?: ICreateFranchiseeDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["devices"])) {
                this.devices = [] as any;
                for (let item of _data["devices"])
                    this.devices!.push(DeviceDTO.fromJS(item));
            }
            else {
                this.devices = <any>null;
            }
        }
    }

    static override fromJS(data: any): CreateFranchiseeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFranchiseeDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.devices)) {
            data["devices"] = [];
            for (let item of this.devices)
                data["devices"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): CreateFranchiseeDTO {
        const json = this.toJSON();
        let result = new CreateFranchiseeDTO();
        result.init(json);
        return result;
    }
}

export interface ICreateFranchiseeDTO extends IFranchiseeDTO {
    devices?: DeviceDTO[] | null;
}

export class UpdateFranchiseeDTO extends CreateFranchiseeDTO implements IUpdateFranchiseeDTO {

    constructor(data?: IUpdateFranchiseeDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): UpdateFranchiseeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFranchiseeDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): UpdateFranchiseeDTO {
        const json = this.toJSON();
        let result = new UpdateFranchiseeDTO();
        result.init(json);
        return result;
    }
}

export interface IUpdateFranchiseeDTO extends ICreateFranchiseeDTO {
}

export class PaginationResponseOfGrindingDTO implements IPaginationResponseOfGrindingDTO {
    page?: number;
    perPage?: number;
    totalPages?: number;
    entities?: GrindingDTO[] | null;

    constructor(data?: IPaginationResponseOfGrindingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"] !== undefined ? _data["page"] : <any>null;
            this.perPage = _data["perPage"] !== undefined ? _data["perPage"] : <any>null;
            this.totalPages = _data["totalPages"] !== undefined ? _data["totalPages"] : <any>null;
            if (Array.isArray(_data["entities"])) {
                this.entities = [] as any;
                for (let item of _data["entities"])
                    this.entities!.push(GrindingDTO.fromJS(item));
            }
            else {
                this.entities = <any>null;
            }
        }
    }

    static fromJS(data: any): PaginationResponseOfGrindingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PaginationResponseOfGrindingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page !== undefined ? this.page : <any>null;
        data["perPage"] = this.perPage !== undefined ? this.perPage : <any>null;
        data["totalPages"] = this.totalPages !== undefined ? this.totalPages : <any>null;
        if (Array.isArray(this.entities)) {
            data["entities"] = [];
            for (let item of this.entities)
                data["entities"].push(item.toJSON());
        }
        return data;
    }

    clone(): PaginationResponseOfGrindingDTO {
        const json = this.toJSON();
        let result = new PaginationResponseOfGrindingDTO();
        result.init(json);
        return result;
    }
}

export interface IPaginationResponseOfGrindingDTO {
    page?: number;
    perPage?: number;
    totalPages?: number;
    entities?: GrindingDTO[] | null;
}

export class Pagination implements IPagination {
    page?: number;
    perPage?: number;

    constructor(data?: IPagination) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"] !== undefined ? _data["page"] : <any>null;
            this.perPage = _data["perPage"] !== undefined ? _data["perPage"] : <any>null;
        }
    }

    static fromJS(data: any): Pagination {
        data = typeof data === 'object' ? data : {};
        let result = new Pagination();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page !== undefined ? this.page : <any>null;
        data["perPage"] = this.perPage !== undefined ? this.perPage : <any>null;
        return data;
    }

    clone(): Pagination {
        const json = this.toJSON();
        let result = new Pagination();
        result.init(json);
        return result;
    }
}

export interface IPagination {
    page?: number;
    perPage?: number;
}

export class DeviceLogDTO extends BaseEntityDTO implements IDeviceLogDTO {
    deviceId?: number;
    type?: LogType;
    value?: string | null;
    insertDate?: moment.Moment;

    constructor(data?: IDeviceLogDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.deviceId = _data["deviceId"] !== undefined ? _data["deviceId"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.insertDate = _data["insertDate"] ? moment(_data["insertDate"].toString()) : <any>null;
        }
    }

    static override fromJS(data: any): DeviceLogDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceLogDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceId"] = this.deviceId !== undefined ? this.deviceId : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["insertDate"] = this.insertDate ? this.insertDate.toISOString() : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): DeviceLogDTO {
        const json = this.toJSON();
        let result = new DeviceLogDTO();
        result.init(json);
        return result;
    }
}

export interface IDeviceLogDTO extends IBaseEntityDTO {
    deviceId?: number;
    type?: LogType;
    value?: string | null;
    insertDate?: moment.Moment;
}

export enum LogType {
    OnlineStatus = 0,
    OfflineStatus = 1,
}

export class StatisticsMillDTO implements IStatisticsMillDTO {
    data?: { [key: string]: any; }[] | null;
    devices?: StatisticsMillDeviceDTO[] | null;
    totalCoffee?: number;
    millCount?: number;

    constructor(data?: IStatisticsMillDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(item);
            }
            else {
                this.data = <any>null;
            }
            if (Array.isArray(_data["devices"])) {
                this.devices = [] as any;
                for (let item of _data["devices"])
                    this.devices!.push(StatisticsMillDeviceDTO.fromJS(item));
            }
            else {
                this.devices = <any>null;
            }
            this.totalCoffee = _data["totalCoffee"] !== undefined ? _data["totalCoffee"] : <any>null;
            this.millCount = _data["millCount"] !== undefined ? _data["millCount"] : <any>null;
        }
    }

    static fromJS(data: any): StatisticsMillDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StatisticsMillDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item);
        }
        if (Array.isArray(this.devices)) {
            data["devices"] = [];
            for (let item of this.devices)
                data["devices"].push(item.toJSON());
        }
        data["totalCoffee"] = this.totalCoffee !== undefined ? this.totalCoffee : <any>null;
        data["millCount"] = this.millCount !== undefined ? this.millCount : <any>null;
        return data;
    }

    clone(): StatisticsMillDTO {
        const json = this.toJSON();
        let result = new StatisticsMillDTO();
        result.init(json);
        return result;
    }
}

export interface IStatisticsMillDTO {
    data?: { [key: string]: any; }[] | null;
    devices?: StatisticsMillDeviceDTO[] | null;
    totalCoffee?: number;
    millCount?: number;
}

export class StatisticsMillDeviceDTO implements IStatisticsMillDeviceDTO {
    key?: string | null;
    name?: string | null;

    constructor(data?: IStatisticsMillDeviceDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"] !== undefined ? _data["key"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): StatisticsMillDeviceDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StatisticsMillDeviceDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key !== undefined ? this.key : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }

    clone(): StatisticsMillDeviceDTO {
        const json = this.toJSON();
        let result = new StatisticsMillDeviceDTO();
        result.init(json);
        return result;
    }
}

export interface IStatisticsMillDeviceDTO {
    key?: string | null;
    name?: string | null;
}

export class UserDTO extends ActiveRowDTO implements IUserDTO {
    login?: string | null;
    password?: string | null;
    role?: Role;
    franchiseeId?: number | null;

    constructor(data?: IUserDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.login = _data["login"] !== undefined ? _data["login"] : <any>null;
            this.password = _data["password"] !== undefined ? _data["password"] : <any>null;
            this.role = _data["role"] !== undefined ? _data["role"] : <any>null;
            this.franchiseeId = _data["franchiseeId"] !== undefined ? _data["franchiseeId"] : <any>null;
        }
    }

    static override fromJS(data: any): UserDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["login"] = this.login !== undefined ? this.login : <any>null;
        data["password"] = this.password !== undefined ? this.password : <any>null;
        data["role"] = this.role !== undefined ? this.role : <any>null;
        data["franchiseeId"] = this.franchiseeId !== undefined ? this.franchiseeId : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): UserDTO {
        const json = this.toJSON();
        let result = new UserDTO();
        result.init(json);
        return result;
    }
}

export interface IUserDTO extends IActiveRowDTO {
    login?: string | null;
    password?: string | null;
    role?: Role;
    franchiseeId?: number | null;
}

export enum Role {
    Admin = 0,
    Owner = 1,
    User = 2,
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}